interface Result {
  name: string
  content: string
}
interface removeAllResult {
  content: string[]
}

interface Get {
  result: Result
  onsuccess: () => void
  onerror: (reason?: any) => void
}

interface Put {
  onsuccess: (target: { result: Result }) => void
  onerror: (reason?: any) => void
}

const SQL_NAME = 'TCMA-manage-org--sql'
const DB_NAME = 'TCMA-manage-org--db'
let request: any
let db: any

const lazyAwait = (time?: number) => {
  console.log('lazyAwait == ', time)
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(true)
    }, time || 160)
  })
}

const lazyBack = async (time = 0) => {
  // console.log('lazyBack == ', time)
  if (!db && time < 3) {
    await lazyAwait()
    await lazyBack(time + 1)
  }
}

// 初始化数据库
function init() {
  return new Promise((resolve, reject) => {
    request = window.indexedDB.open(SQL_NAME)
    request.onerror = (event: any) => {
      console.log('tcma-sql 缓存获取失败')
      reject(event)
    }
    request.onsuccess = (event: any) => {
      console.log('tcma-sql 缓存获取成功')
      resolve(event.target.result)
      db = event.target.result
    }
    request.onupgradeneeded = (event: any) => {
      console.log('tcma-sql onupgradeneeded')
      db = event.target.result
      let objectStore
      if (!db.objectStoreNames.contains(DB_NAME)) {
        // 创建数据库
        objectStore = db.createObjectStore(DB_NAME, {
          keyPath: 'name',
          unique: true, // 使用name名称作为主键，且不允许重复
        })
        objectStore.createIndex('content', 'content', { unique: false }) // 建立索引
      }
    }
  })
}

// get操作，读取数据
export async function get(name: string): Promise<Result> {
  return new Promise<Result>(async (resolve, reject) => {
    await lazyBack(0)
    console.log('db == ', db, name)
    if (!db) {
      reject()
    }
    const select: Get = db.transaction([DB_NAME], 'readonly').objectStore(DB_NAME).get(name)

    select.onsuccess = function () {
      console.log('select.result == ', select.result)
      resolve(select.result)
    }
    select.onerror = reject
  })
}

// add操作，添加数据
export async function add(name: string, content: string): Promise<Result> {
  return new Promise<Result>(async (resolve, reject) => {
    await lazyBack(0)
    if (!db) {
      reject()
    }
    const select: Put = db.transaction([DB_NAME], 'readwrite').objectStore(DB_NAME).add({ name: name, content })

    select.onsuccess = (event: any) => {
      resolve(event.target.result)
    }
    select.onerror = reject
  })
}

// update操作，更新数据
export async function update(name: string, content: string): Promise<Result> {
  return new Promise<Result>(async (resolve, reject) => {
    await lazyBack(0)
    if (!db) {
      reject()
    }
    const select: Put = db.transaction([DB_NAME], 'readwrite').objectStore(DB_NAME).put({ name, content })

    select.onsuccess = (event: any) => {
      resolve(event.target.result)
    }
    select.onerror = reject
  })
}

// remove操作，删除数据
export async function remove(name: string): Promise<Result> {
  return new Promise<Result>(async (resolve, reject) => {
    await lazyBack(0)
    if (!db) {
      reject()
    }
    const select: Put = db.transaction([DB_NAME], 'readwrite').objectStore(DB_NAME).delete(name)

    select.onsuccess = (event: any) => {
      resolve(event.target.result)
    }
    select.onerror = reject
  })
}
// 移除所有数据
export async function removeAll(): Promise<removeAllResult> {
  return new Promise((resolve, reject) => {
    console.log('db == ', db, DB_NAME)
    if (!db) {
      return reject()
    }
    const select: Put = db.transaction([DB_NAME], 'readonly').objectStore(DB_NAME).getAllKeys()

    select.onsuccess = (event: any) => {
      // @ts-ignore
      console.log('getAllKeys == ', event)
      resolve({
        content: event.target.result,
      })
    }
    select.onerror = reject
  })
}

export default {
  init,
  add,
  get,
  update,
  remove,
  removeAll,
}
